import {defineStore} from 'pinia'
import enumService from "@/api/Enum";
import {ErrorToast} from "@/components/VueToast";


export const piniaEnumsStore = defineStore('enums', {
    // state: () => {
    //     return {
    //         enums: {
    //             federalStates: []
    //         }
    //     }
    // },
    state: () => ({
        enums: {} as any
    }),
    persist: true,
    actions: {
        async getEnums() {
            try {
                const {data} = await enumService.getEnums();
                this.enums = data.data
            } catch (err) {
                // await ErrorToast(err, undefined, '');
            }
        }
    }
})